import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledImageWrapper = styled.div`
  position: relative;
  min-width: 0;
  width: 85px;
  height: 85px;
`

const ImageWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledImageWrapper>{children}</StyledImageWrapper>

export default ImageWrapper
